import script from "./GlobalActionsManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalActionsManager.vue?vue&type=script&setup=true&lang=ts"

export default script